// Module
var code = "<react-component name=\"Subscriptions\"></react-component>\n";
// Exports
module.exports = code;